import styled from 'styled-components';

export const StyledSecondStep = styled.div`
  .ss-wrapper {
    > h3 {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: var(--color-charcoal-black);
      margin-bottom: 20px;

      > span {
        font-weight: 700;
      }
    }

    &-box {
      border: 1px solid var(--color-light-gray) !important;
      border-radius: 6px;

      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > input {
          width: 40px !important;
        }
      }
    }
  }
`;

export const StyledCodeSpan = styled.span`
  color: var();
`;
